/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ClaimLeverageGetAccruedInterestOptions,
  ClaimLeverageGetAccruedInterestStatus200,
  ClaimLeverageGetAccruedInterestStatus400,
  ClaimLeverageGetAccruedInterestStatus401,
  ClaimLeverageGetAccruedInterestStatus500,
} from '../types/ClaimLeverageGetAccruedInterest'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { claimLeverageGetAccruedInterest } from '../clients/claimLeverageGetAccruedInterest'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const claimLeverageGetAccruedInterestMutationKey = () =>
  [{ url: '/v1/leverage/accrued_interest/claim' }] as const

export function claimLeverageGetAccruedInterestMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = claimLeverageGetAccruedInterestMutationKey()
  return mutationOptions<
    ClaimLeverageGetAccruedInterestStatus200,
    ResponseErrorConfig<
      | ClaimLeverageGetAccruedInterestStatus400
      | ClaimLeverageGetAccruedInterestStatus401
      | ClaimLeverageGetAccruedInterestStatus500
    >,
    ClaimLeverageGetAccruedInterestOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return claimLeverageGetAccruedInterest({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Claim current accrued leverage interest for a specific user
 * {@link /v1/leverage/accrued_interest/claim}
 */
export function useClaimLeverageGetAccruedInterest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ClaimLeverageGetAccruedInterestStatus200,
      ResponseErrorConfig<
        | ClaimLeverageGetAccruedInterestStatus400
        | ClaimLeverageGetAccruedInterestStatus401
        | ClaimLeverageGetAccruedInterestStatus500
      >,
      ClaimLeverageGetAccruedInterestOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? claimLeverageGetAccruedInterestMutationKey()

  const baseOptions = claimLeverageGetAccruedInterestMutationOptions(config) as UseMutationOptions<
    ClaimLeverageGetAccruedInterestStatus200,
    ResponseErrorConfig<
      | ClaimLeverageGetAccruedInterestStatus400
      | ClaimLeverageGetAccruedInterestStatus401
      | ClaimLeverageGetAccruedInterestStatus500
    >,
    ClaimLeverageGetAccruedInterestOptions,
    TContext
  >

  return useMutation<
    ClaimLeverageGetAccruedInterestStatus200,
    ResponseErrorConfig<
      | ClaimLeverageGetAccruedInterestStatus400
      | ClaimLeverageGetAccruedInterestStatus401
      | ClaimLeverageGetAccruedInterestStatus500
    >,
    ClaimLeverageGetAccruedInterestOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ClaimLeverageGetAccruedInterestStatus200,
    ResponseErrorConfig<
      | ClaimLeverageGetAccruedInterestStatus400
      | ClaimLeverageGetAccruedInterestStatus401
      | ClaimLeverageGetAccruedInterestStatus500
    >,
    ClaimLeverageGetAccruedInterestOptions,
    TContext
  >
}
